import { Fragment } from 'react';

import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from '../../Entry.module.css';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const GridRow = ({ credential, onCheckboxChange }) => {
  return (
    <tr key={credential.orgUnitNonAthleteEntryId}>
      <td>{(credential.firstName || credential.middleName || credential.lastName) ? `${credential.firstName || ''}  ${credential.preferredName !== '' && credential.preferredName !== credential.firstName ? '"' + credential.preferredName + '"' : ''} ${credential.middleName || ''} ${credential.lastName || ''}` : ''}</td>
      <td>{credential.orgUnitName || ''} {credential.parentOrgUnitCode ? '(' + credential.parentOrgUnitCode + ')' : ''}</td>
      <td>{credential.memberId || ''}</td>
      <td className={style.Email}>{credential.email || ''}</td>
      <td>{credential.isInGoodStanding === true ? 'Yes' : credential.isInGoodStanding === false ? 'No' : ''}{credential.isInGoodStandingExpirationDate ? ` (${formatDate(credential.isInGoodStandingExpirationDate)})` : ''}</td>
      <td>
        <Fragment>
          {credential.credentialEntered === false ?
            <Fragment>
              {credential.hasPaid === false ?
                <Checkbox
                  label=""
                  name="isSelected"
                  onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                  checked={credential.isSelected} />
                :
                <Checkbox
                  label=""
                  name="isSelected"
                  onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                  checked={credential.isSelected}
                  disabled={true} />}
            </Fragment>
            :
            <div className='pull-left'>
              <Checkbox
                className={global.IconButton}
                label=""
                name="isSelected"
                onChange={(e) => { onCheckboxChange(e, credential.personId) }}
                checked={true}
                disabled={true} />
            </div>}
          {credential.credentialEntered === true &&
            <div style={{  minWidth: '140px', marginLeft: '30px' }}>{credential.credentialEnteredOmeMeetName ? `Entered under ${credential.credentialEnteredOmeMeetName}` : ''}</div>}
        </Fragment>
      </td>
    </tr>
  );
};

const AthleteUserCredentialsSelectionLargeGrid = ({ gridData, isLoading, onCheckboxChange }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Name</th>
        <th>Organization</th>
        <th style={{ minWidth: '130px' }}>Member Id</th>
        <th>Email</th>
        <th style={{ width: '170px' }}>Is In Good Standing? (Expiration Date)</th>
        <th>Select</th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan="6">Loading...</td></tr>
        : Array.isArray(gridData) && gridData?.length > 0 ?
          gridData?.map((credential, i) =>
            <GridRow
              key={i}
              credential={credential}
              onCheckboxChange={onCheckboxChange} />)
          :
          <tr>
            <td colSpan={6}>No Results</td>
          </tr>
      }
    </tbody>
  </table>
);

export default AthleteUserCredentialsSelectionLargeGrid;